import { OfficeWorkload, } from '@office-start/officehome-types';
function getWdOriginApp(workload) {
    switch (workload) {
        case OfficeWorkload.Antp:
            return "NTP" /* WdOriginApp.NTP */;
        case OfficeWorkload.Hwa:
            return "HWA" /* WdOriginApp.HWA */;
    }
    // TODO: Detect PWA
    // if (this.isStandalone) {
    //     return WdOriginApp.PWA;
    // }
    return "WEB" /* WdOriginApp.Web */;
}
function getWdOriginPage(route) {
    if (route) {
        switch (route.route) {
            case 'Start':
                return "START" /* WdOriginPage.Start */;
            case 'Templates':
                return "TEMPLATES" /* WdOriginPage.Templates */;
            case 'Content':
                return "CONTENT" /* WdOriginPage.Content */;
            case 'Search':
                return "SEARCH" /* WdOriginPage.Search */;
            default:
                return "MAIN" /* WdOriginPage.Home */;
        }
    }
    return "MAIN" /* WdOriginPage.Home */;
}
export function getWdOrigin(workload, route, type) {
    return "OFFICECOM-".concat(getWdOriginApp(workload), ".").concat(getWdOriginPage(route), ".").concat(type);
}
//# sourceMappingURL=getWdOrigin.js.map